import { ErrorOutline } from '@mui/icons-material';
import { Box, Typography, Button, Paper } from '@mui/material';
import React from 'react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      minHeight='100vh'
      p={2}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <ErrorOutline color='error' sx={{ fontSize: 64, mb: 2 }} />
        <Typography variant='h5' gutterBottom>
          Something went wrong
        </Typography>
        <Typography variant='body1' color='text.secondary' paragraph>
          {error.message}
        </Typography>
        <Button variant='contained' onClick={resetErrorBoundary} sx={{ mt: 2 }}>
          Try again
        </Button>
      </Paper>
    </Box>
  );
};
